import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import { size, get } from 'lodash';
import Link from 'react-router/lib/Link';

import { COMPLAINT_TYPE } from '../../../../constants';
import Avatar from '../../../Avatar';
import Header from '../../../PostPreview/Header';
import Heading from '../../../Comment/Heading';
import styles from './styles.styl';
import Body from '../../../PostPreview/Body';
import Image from '../../../PostPreview/Image';
import Video from '../../../PostPreview/Video';
import UrlPreview from '../../../Community/NewPost/UrlPreview';

export const ReportPreviewImpl = ({
  attachment,
  author,
  createdAt,
  updated,
  content,
  comments,
  type,
  path,
}) => {
  const isPost = type === COMPLAINT_TYPE.POST;
  const images = get(attachment, 'files');
  const link = get(attachment, 'urlPreview');

  const aliasName = get(author, 'user.aliasName');

  const getHeader = () => {
    if (isPost) {
      return <Header author={author} createdAt={createdAt} updated={updated} />;
    }

    return (
      <Heading
        userName={aliasName}
        comments={comments}
        createdAt={createdAt}
        updated={updated}
      />
    );
  };
  const header = getHeader();
  return (
    <Link to={path} styleName="root">
      <div styleName="grid">
        <div styleName="avatar">
          <Avatar
            children={aliasName}
            size={40}
            src={get(author, 'user.avatar.thumbMin')}
          />
        </div>
        <div styleName="content">{header}</div>
      </div>
      <If condition={content}>
        <Body {...{ content }} className="pl0 mt2 mb2" />
      </If>
      <If condition={size(images)}>
        <div styleName="images">
          {images.map(image => (
            <div styleName="images-item" key={image.index}>
              <Image
                image={image}
                key={image.index}
                relative
                className="lazy-image-wrapper"
              />
            </div>
          ))}
        </div>
      </If>
      <If condition={get(link, 'url')}>
        <Choose>
          <When condition={link.video && link.video !== 'null'}>
            <Video src={link.video} />
          </When>
          <Otherwise>
            <UrlPreview {...link} readonly />
          </Otherwise>
        </Choose>
      </If>
    </Link>
  );
};

export const ReportPreview = compose(
  CSSModules(styles, { allowMultiple: true }),
)(ReportPreviewImpl);

const propTypes = {
  attachment: PropTypes.object,
  comments: PropTypes.array,
  author: PropTypes.object.isRequired,
  createdAt: PropTypes.string.isRequired,
  updated: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};
const defaultProps = {
  comments: [],
  attachment: null,
};
ReportPreviewImpl.propTypes = propTypes;
ReportPreviewImpl.defaultProps = defaultProps;
ReportPreview.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/Communities/Reports/ReportPreview/index.jsx